import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';

import compactFieldSx from './compactFieldSx';

// Start and end dates as YYYY-MM-DD strings, for report filter rows.
const ReportDateRange = ({ startDateStr, endDateStr, onStartChange, onEndChange }) => (
  <>
    <TextField
      label="Start date"
      type="date"
      size="small"
      sx={compactFieldSx}
      value={startDateStr}
      onChange={(event) => onStartChange(event.target.value)}
      InputLabelProps={{ shrink: true }}
      inputProps={{ max: endDateStr }}
    />
    <TextField
      label="End date"
      type="date"
      size="small"
      sx={compactFieldSx}
      value={endDateStr}
      onChange={(event) => onEndChange(event.target.value)}
      InputLabelProps={{ shrink: true }}
      inputProps={{ min: startDateStr }}
    />
  </>
);

ReportDateRange.propTypes = {
  startDateStr: PropTypes.string.isRequired,
  endDateStr: PropTypes.string.isRequired,
  onStartChange: PropTypes.func.isRequired,
  onEndChange: PropTypes.func.isRequired,
};

export default ReportDateRange;
